/**
 * external libs
 */
import React, {createContext, useState} from 'react';
import {useTranslation} from "react-i18next";
/**
 * locales
 */
import useKeyPressedHook from "../../hooks/useKeyPressed.hook";


export const KeyPressedContext = createContext({});

export function KeyPressedContextProvider({children}) {
    const {pressedKey} = useKeyPressedHook()

    return <KeyPressedContext.Provider value={{pressedKey}}>{children}</KeyPressedContext.Provider>
}
